import React from 'react';

const Wrapper = ({ children }: any) => (
    <div className='wrapper'>{children}</div>
);

export default Wrapper;